/* ==== Protection checkbox's behavior ==== */
async function checkProtectionPrice() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    if (cart.attributes && cart.attributes._protection_price) {
      return true;
    }
    return false;
  } catch (error) {
    console.error(error);
    return false;
  }
}

var protectionPlanPDP = false;

window.addEventListener('DOMContentLoaded', function () {
  const protectionLabel = document.querySelector('.cartItem_protection_plan');
  const preSelectedProtection = document.querySelector('.wrap_pdp_protection')?.dataset.preSelectedProtection;

  if (protectionLabel) {
    protectionLabel.addEventListener('click', function () {
      const isChecked = protectionLabel.classList.contains('is_checked');
      protectionPlanPDP = isChecked;
    });
  }

  if (preSelectedProtection == 'true') {
    protectionLabel.click();
  }
});

function cartitem_checkbox_click_event() {
  document.querySelectorAll('.cartItem_protection_plan').forEach(($this) => {
    $this.addEventListener('click', function (event) {
      event.preventDefault();
      if ($this.classList.contains('is_checked')) {
        $this.classList.remove('is_checked');
        $this.setAttribute('aria-checked', 'false');
      } else {
        $this.classList.add('is_checked');
        $this.setAttribute('aria-checked', 'true');
      }

      // if (
      //   document.querySelector('.cart_checkout_btn') &&
      //   !document.querySelector('.cart_checkout_btn').hasAttribute('disabled')
      // ) {
      //   document.querySelector('.cart_checkout_btn').disabled = true;
      // }

      $set_cartitem_protection($this);
    });
  });
}

async function $set_cartitem_protection($this) {
  const ProtectionSel = $this.classList.contains('is_checked') ? 'true' : 'false';
  const cartItemElement = $this.closest('.cart-item[data-protection="true"]');

  if (!cartItemElement) return;

  let lineItemQty = cartItemElement.querySelector('.quantity__input').value;
  let lineId = cartItemElement.dataset.itemid;
  let lineKey = cartItemElement.dataset.key;
  let lineProperties = cartItemElement.dataset.property;

  // Ensure properties are in valid JSON format
  const validJson = lineProperties.replace(/'/g, '"');
  const itemProperties = JSON.parse(validJson).filter((prop) => prop.name !== '_protection_plan_selected');

  let newLineItemProperties = {
    _protection_plan_selected: ProtectionSel,
    ...Object.fromEntries(itemProperties.map((prop) => [prop.name, prop.value])),
  };

  let dataItem = { id: lineKey, quantity: lineItemQty, properties: newLineItemProperties };

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dataItem),
  })
    .then((response) => response.json())
    .then((updatedCart) => {
      $update_cart_page(updatedCart);
    })
    .catch((error) => console.error('Error updating cart:', error));
}

async function removeProtectionPlanProduct(productId) {
  try {
    const cart = await fetch('/cart.js').then(res => res.json());

    const removalRequests = cart.items
      .filter(item => item.product_id === Number(productId))
      .map(item =>
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        })
      );

    await Promise.all(removalRequests);

    if (typeof $update_cart_page === 'function') {
      const updatedCart = await fetch('/cart.js').then(res => res.json());
      $update_cart_page(updatedCart);
    }
  } catch (err) {
    console.error('Error removing protection plan variants:', err);
  }
}

window.addEventListener('DOMContentLoaded', function () {
  const protectionPrdoctId = document.getElementById("protection-plans--variants").getAttribute('data-product-id');
  removeProtectionPlanProduct(protectionPrdoctId);
});


cartitem_checkbox_click_event();

// PDP and Cart page see what's covered controller with ADA keyboard trap focus
function initializeProtectionButtons() {
  const sidebarOverlay = document.getElementById('sidebar-overlay');
  const sidebarContent = document.getElementById('sidebar-content');
  const closeBtn = document.getElementById('content__close_btn');
  let lastFocusedElement = null;

  function openSidebar() {
    lastFocusedElement = document.activeElement;
    
    if (sidebarOverlay) {
      sidebarOverlay.classList.add('active');
    }
    
    if (sidebarContent) {
      sidebarContent.classList.add('active');
    }
    
    document.querySelector('html').classList.add('no-scroll');
    
    if (typeof trapFocus === 'function' && sidebarContent && closeBtn) {
      trapFocus(sidebarContent, closeBtn);
    }
  }

  function closeSidebar() {
    if (sidebarOverlay) {
      sidebarOverlay.classList.remove('active');
    }
    
    if (sidebarContent) {
      sidebarContent.classList.remove('active');
    }
    
    document.querySelector('html').classList.remove('no-scroll');
    
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(lastFocusedElement || document.querySelector('[id^="covered_plans_btn"]'));
    }
  }

  const pdpBtn = document.getElementById('covered_plans_btn');
  if (pdpBtn) {
    pdpBtn.addEventListener('click', openSidebar);
  }

  const cartButtons = document.querySelectorAll('[id^="covered_plans_btn_cart"]');
  cartButtons.forEach(button => {
    button.setAttribute('type', 'button');
    
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openSidebar();
    });
  });

  if (sidebarOverlay) {
    sidebarOverlay.addEventListener('click', closeSidebar);
  }
  
  if (closeBtn) {
    closeBtn.addEventListener('click', closeSidebar);
  }
  
  if (sidebarContent) {
    sidebarContent.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeSidebar();
      }
    });
  }
}

window.addEventListener('DOMContentLoaded', function() {
  const hasPdpButton = document.getElementById('covered_plans_btn');
  const hasCartButtons = document.querySelectorAll('[id^="covered_plans_btn_cart"]').length > 0;
  
  if (hasPdpButton || hasCartButtons) {
    initializeProtectionButtons();
  }
});

document.addEventListener('cart:updated', function() {
  const cartButtons = document.querySelectorAll('[id^="covered_plans_btn_cart"]');
  if (cartButtons.length > 0) {
    initializeProtectionButtons();
  }
});

setTimeout(function() {
  const hasPdpButton = document.getElementById('covered_plans_btn');
  const hasCartButtons = document.querySelectorAll('[id^="covered_plans_btn_cart"]').length > 0;
  
  if (hasPdpButton || hasCartButtons) {
    initializeProtectionButtons();
  }
}, 1000);

// ADA feature to control the protection checkbox on PDP and Cart Page
document.addEventListener('keydown', function(e) {
  const label = e.target;
  if (
    label.classList &&
    label.classList.contains('cartItem_protection_plan') &&
    (e.key === ' ' || e.key === 'Enter')
  ) {
    e.preventDefault();
    label.click();
  }
});
